import type { ReactElement } from 'react';
import { Container, ErrorMessage, Image, Title, HeaderWrapper } from './styles';
import { Footer, Header } from '@/components/organisms';

function NoAccess(): ReactElement {
  return (
    <Container>
      <HeaderWrapper>
        <Header />
      </HeaderWrapper>
      <ErrorMessage>
        <Image
          src="assets/images/no-access-2.svg"
          alt="Você não tem acessso à esta página"
        />
        <Title>Ops, você não tem acesso</Title>
        <p>
          Parece que você não tem acesso a esta página. Em caso de dúvidas,
          entre em contato conosco pelo e-mail{' '}
          <a href="mailto:msc@betrybe.com">msc@betrybe.com</a>
        </p>
      </ErrorMessage>
      <Footer />
    </Container>
  );
}

export default NoAccess;
